import React, { useEffect, useState } from "react";
import { BasicPage } from "../../theme/Component/BasicPage";
import useDataBean from "../../../core/services/dataBean/useDataBean";
import { _single, _Sprint } from "../../../core/services/dataBean/EntityCatalog";
import { toast } from "react-toastify";
import useModal, { MODAL_md, MODAL_SM } from "../../theme/Component/hooks/useModal";
import { BasicButton } from "../../theme/Component/BasicButton";
import { Modal } from "../../theme/Component/Modal";
import { InputDate } from "../../theme/Input/InputDate";
import { SprintSection } from "./Components/SprintSection/SprintSection";
import { BacklogSection } from "./Components/BacklogSection/BacklogSection";
import { useSprintBoardContext } from "../ActivityTaskContext/SprintBoardProvider";
import { SelectProject } from "../../erp/cellEditor/BudgetAccountantOperation/SelectProject";

type SprintBean = {
    IDSprint: number;
    SprintName?: string;
    FromDate?: string;
    UptoDate?: string;
    [key: string]: any;
};

type Sprint = {
    DataBeanProperties: SprintBean;
    DataBeanName: string;
};

export const Sprint = () => {
    const {
        sprints,
        loadSprints,
        paginadorSprint: paginador,
        setFilterSprints,
        filterSprints
    } = useSprintBoardContext();
    const { instance, bean, setBean, isMissing, isRequired, validateForm, addRequiredFields } = useDataBean(_Sprint);

    const [expanded, setExpanded] = useState<Record<number, boolean>>({});
    const [sprintFilterForm, setSprintFilterForm] = useState({
        IDProject: filterSprints.IDProject,
    });

    const modal = useModal("", MODAL_md);

    useEffect(() => {
        loadSprints();
    }, [paginador.page]);

    useEffect(() => {
        addRequiredFields(["SprintName", "FromDate", "UptoDate"])
    }, [])


    const create = () => {
        setBean({
            State: 1,
            FromDate: _single.getCurrenDate(),
            UptoDate: _single.getCurrenDate(),
            IDAccount: _single.getAccountID(),
        });

        modal.open("Agregar Periodo de tiempo");
    };

    const editaItem = (obj: any) => {
        if (!validateForm()) {
            toast.error("Faltan campos Obligatorios por dilienciar")
            return;
        }

        const x = { ...obj, IDAccount: _single.getAccountID() }

        instance.updateSprint(x).then(
            () => {
                loadSprints();
                modal.close();
            }
        ).catch((err) => toast.error(err));
    };

    const toggleSprint = (id: number) => {
        setExpanded((prev) => ({
            ...prev,
            [id]: !prev[id],
        }));
    };

    const searchSprints = () => {
        const filters = {
            IDProject: sprintFilterForm.IDProject,
        };

        setFilterSprints(filters);
        paginador.setPage(1);
        loadSprints(filters, 1);
    };

    const buildPages = () => {
        const result: number[] = [];
        const maxVisible = 5;

        let start = Math.max(1, paginador.page - 2);
        let end = Math.min(paginador.pages, start + maxVisible - 1);

        if (end - start < maxVisible - 1) {
            start = Math.max(1, end - maxVisible + 1);
        }

        for (let i = start; i <= end; i++) {
            result.push(i);
        }

        return result;
    };

    return (
        <BasicPage titulo="Periodos de Trabajo">
            <div className="row">
                <div className="col-md-4">
                    <SelectProject
                        idSelector={sprintFilterForm.IDProject}
                        onChange={(e) => {
                            setSprintFilterForm({ ...sprintFilterForm, IDProject: e });
                        }}
                        label="Filtro periodos por proyecto"
                    />
                </div>

                <div className="col-md-2 d-flex align-items-end">
                    <BasicButton
                        icon="ri-search-line"
                        eventClick={searchSprints}
                        children="Buscar"
                        useMargin
                    />
                </div>

                <div className="col-md-4 ">
                    <BasicButton
                        icon="ri-file-add-line"
                        eventClick={create}
                        children="Agregar Periodo de Trabajo"
                        useMargin
                    />
                </div>

                <div className="col-md-12 mt-3">
                    {paginador.pages > 1 && (
                        <div
                            style={{
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                gap: 6,
                                padding: "20px 0"
                            }}
                        >
                            <button
                                onClick={() => {
                                    if (paginador.page > 1)
                                        paginador.setPage(paginador.page - 1);
                                }}
                                disabled={paginador.page === 1}
                                style={{
                                    border: "none",
                                    background: "transparent",
                                    cursor: paginador.page === 1 ? "default" : "pointer",
                                    opacity: paginador.page === 1 ? 0.4 : 0.8,
                                    padding: "4px 8px"
                                }}
                            >
                                ◀
                            </button>

                            {buildPages().map((p) => (
                                <button
                                    key={p}
                                    onClick={() => paginador.setPage(p)}
                                    style={{
                                        border: "none",
                                        background:
                                            p === paginador.page
                                                ? "rgba(0,0,0,0.08)"
                                                : "transparent",
                                        cursor: "pointer",
                                        padding: "4px 8px",
                                        borderRadius: 4,
                                        fontWeight: p === paginador.page ? 600 : 400
                                    }}
                                >
                                    {p}
                                </button>
                            ))}

                            <button
                                onClick={() => {
                                    if (paginador.page < paginador.pages)
                                        paginador.setPage(paginador.page + 1);
                                }}
                                disabled={paginador.page === paginador.pages}
                                style={{
                                    border: "none",
                                    background: "transparent",
                                    cursor:
                                        paginador.page === paginador.pages
                                            ? "default"
                                            : "pointer",
                                    opacity:
                                        paginador.page === paginador.pages ? 0.4 : 0.8,
                                    padding: "4px 8px"
                                }}
                            >
                                ▶
                            </button>
                        </div>
                    )}
                </div>

                <div className="col-md-12">
                    {sprints.map((s) => {
                        const id = s.DataBeanProperties.IDSprint;

                        return (
                            <SprintSection
                                key={id}
                                sprint={s}
                                expanded={!!expanded[id]}
                                onToggle={() => toggleSprint(id)}
                            />
                        );
                    })}
                </div>

                <div className="col-md-12">
                    <BacklogSection />
                </div>

                <div className="col-md-12">
                    <Modal modal={modal.modal} updateModal={modal.setModal} eventModal={() => editaItem(bean)}>
                        <div className="row">
                            <div className="col-md-12">
                                <label className={`${isMissing('SprintName') ? 'has-error' : ''}`}>Declaracion de importación {isRequired('SprintName') ? <span className="text-danger">*</span> : ''}</label>
                                <input
                                    className="form-control"
                                    value={bean.SprintName}
                                    onChange={(e) =>
                                        setBean({ ...bean, SprintName: e.target.value })
                                    }
                                />
                            </div>

                            <div className="col-md-12">
                                <label className={`${isMissing('IDProject') ? 'has-error' : ''}`}>Proyecto Asociado {isRequired('IDProject') ? <span className="text-danger">*</span> : ''}</label>
                                <SelectProject idSelector={bean.IDProject} onChange={(e) => { setBean({ ...bean, IDProject: e }) }} label=" " />
                            </div>

                            <div className="col-md-12">
                                <label className={`${isMissing('FromDate') ? 'has-error' : ''}`}>Fecha de Inicio {isRequired('FromDate') ? <span className="text-danger">*</span> : ''}</label>

                                <InputDate
                                    name="FromDate"
                                    label=" "
                                    value={bean.FromDate}
                                    setDate={(e) =>
                                        setBean({ ...bean, FromDate: e })
                                    }
                                />
                            </div>

                            <div className="col-md-12">
                                <label className={`${isMissing('UptoDate') ? 'has-error' : ''}`}>Fecha de Finalización {isRequired('UptoDate') ? <span className="text-danger">*</span> : ''}</label>

                                <InputDate
                                    name="UptoDate"
                                    label=" "
                                    value={bean.UptoDate}
                                    setDate={(e) =>
                                        setBean({ ...bean, UptoDate: e })
                                    }
                                />
                            </div>
                        </div>
                    </Modal>
                </div>
            </div>
        </BasicPage>
    );
};
